/*  Usage:
 *	var alertMsg = new AlertMsg('This is the message');
 *	$('form[name=sendMoney]').prepend(alertMsg.el);
*/

define(['jquery', 'backbone', 'BaseView'],

function ($, Backbone, BaseView) {
	'use strict';

	var AlertMsg = BaseView.extend({
		className: 'twbs_alert vx_alert vx_alert-critical js_alertMsg',
		template: 'widgets/alertMsg',

		initialize: function(message) {
			this.model = new Backbone.Model({message: message});
			this.listenTo(this.model, 'change:message', this.render);
			this.render();
		},

		setMessage: function(message) {
			this.model.set('message', message);
			return this;
		}
	});

	return AlertMsg;
});



//////////////////
// WEBPACK FOOTER
// ./widgets/alertMsg.js
// module id = 48
// module chunks = 0